export default {
  'SET_ITEM'(state, payload) {
    const {topic, message } = payload;
    state.mapping[topic] = message;
    state.serialized = JSON.stringify(state.mapping);
  },
  'RESET_MAPPING'(state) {
    const serializedCopy = JSON.stringify(state.mapping);
    state.mapping = {};
    state.mapping = JSON.parse(serializedCopy);
    state.serialized = JSON.stringify(state.mapping);
  },
  'SET_TOPIC_FAMILIES'(state, payload) {
    state.topicFamilies = payload;
  },
  'SET_COMMAND_TOPIC'(state, data) {
    state.commandTopic = data;
  },
  'SET_MQTT_CONNECTED'(state, data) {
    state.mqttConnected = data;
  },
  'APPEND_COMMAND_TO_HISTORY'(state, data) {
    state.commandHistory.push(data);
  },
  'SET_INITIAL_FEEDBACK_HISTORY'(state, data) {
    data.forEach(item => {
      state.feedbackHistory.push(item);
    });
  },
  'APPEND_FEEDBACK_TO_HISTORY'(state, data) {
    state.feedbackHistory.push(data);
  },
  'SET_LOCAL_ACCESS'(state, data) {
    state.localAccess = data;
  }
};